import * as React from "react";
import type { SVGProps } from "react";
const SvgForwardSlash = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={32}
    fill="none"
    viewBox="0 0 19 32" {...props}
  >
    <path stroke="#0D1B27" strokeOpacity={0.87} d="M18.5 1 .5 31" />
  </svg>
);
export default SvgForwardSlash;
